export const DATA = 'data'
export const RAW = 'raw'
export const ENRICHED = 'enriched'

export const ENRICHED_DISABLED_MESSAGE = (
  <span>
    Changes to Raw detected!
    <br />
    Please save to enable Enriched view.
  </span>
)

// Max size for measurement fields in meters
export const MAX_MEASUREMENT_SIZES = {
  length: 8.0,
  width: 1.8,
  height: 1.8,
  rebarLength: 99.999,
  rebarWidth: 0.999
}
